import Vue from 'vue';

export default {
    namespaced: true,

    state: {
        customer: {
            id: 0,
            firstName: null,
            lastName: null,
            fullName: null,
            email: null,
            shippingAddresses: [],
            billingAddresses: []
        }
    },

    getters: {
        isLoaded: (state) => {
            return state.customer && state.customer.id !== 0;
        },

        get: (state) => () => {
            return state.customer;
        },

        getShippingAddresses: (state) => () => {
            return state.customer.shippingAddresses;
        }
    },

    mutations: {
        clear(state) {
            state.customer = {
                id: 0,
                firstName: null,
                lastName: null,
                fullName: null,
                email: null,
                shippingAddresses: [],
                billingAddresses: []
            };
        },

        set(state, { customer }) {
            for(let key of Object.keys(customer)) {
                Vue.set(state.customer, key, customer[key]);
            }

            if(!state.customer.shippingAddresses) 
                Vue.set(state.customer, 'shippingAddresses', []);
            if(!state.customer.billingAddresses)
                Vue.set(state.customer, 'billingAddresses', []);
        },

        addShippingAddress(state, address) {
            state.customer.shippingAddresses.push(address);
        },

        removeShippingAddress(state, address) {
            const idx = state.customer.shippingAddresses.indexOf(address);
            if(idx !== -1) {
                state.customer.shippingAddresses.splice(idx, 1);
            }
        },

        setShippingAddresses(state, { addresses }) {
            if(addresses)
                Vue.set(state.customer, 'shippingAddresses', addresses);
        },

        addBillingAddress(state, address) {
            const found = state.customer.billingAddresses.find(item => item.id === address.id);
            if(found) {
                for(let key of Object.keys(address)) {
                    Vue.set(found, key, address[key]);
                }
            }
            else {
                state.customer.billingAddresses.push(address);
            }
        },

        removeBillingAddress(state, address) {
            const idx = state.customer.billingAddresses.indexOf(address);
            if(idx !== -1) {
                state.customer.billingAddresses.splice(idx, 1);
            }
        },

        setBillingAddresses(state, { addresses }) {
            if(addresses)
                Vue.set(state.customer, 'billingAddresses', addresses);
        }
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },

        async fetch({commit}, id) {
            let result = await this._vm.$api.get('/api/customers/' + id);
            commit('set', {
                customer: result
            });
        },

        fetchShippingAddresses({commit, state}) {
            return this._vm.$api.getCustomerShippingAddresses(state.customer.id).then((addresses) => {
                commit('setShippingAddresses', { addresses: addresses });
            });
        },

        fetchBillingAddresses({commit, state}) {
            return this._vm.$api.getCustomerBillingAddresses(state.customer.id).then((addresses) => {
                commit('setBillingAddresses', { addresses: addresses });
            });
        },

        patch({commit, state}, data) {
            return this._vm.$api.setCustomerInfo(state.customer.id, data).then((user) => {
                commit('set', user);
            });
        },

        addShippingAddress({commit, state}, address) {
            return this._vm.$api.addCustomerShippingAddress(state.customer.id, address).then((response) => {
                commit('addShippingAddress', response);

                return response;
            });
        },

        removeShippingAddress({commit, state}, address) {
            return this._vm.$api.removeCustomerShippingAddress(state.customer.id, address.id).then((/*response*/) => {
                commit('removeShippingAddress', address);
            });
        },

        async addBillingAddress({commit, state}, { data }) {
            let response = await this._vm.$api.post('/api/customers/' + state.customer.id + '/billingAddresses', data);
            commit('addBillingAddress', response);
            return response;
        },

        async updateBillingAddress({ commit, state }, { address, data }) {
            let response = await this._vm.$api.patch('/api/customers/' + state.customer.id + '/billingAddresses/' + address.id, data);
            commit('addBillingAddress', response);
            return response;
        },

        removeBillingAddress({commit, state}, address) {
            return this._vm.$api.removeCustomerBillingAddress(state.customer.id, address.id).then((/*response*/) => {
                commit('removeBillingAddress', address);
            });
        }
    }
}